import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try {
            const s = localStorage.getItem("gb_user");
            return s ? JSON.parse(s) : null;
        } catch {
            return null;
        }
    });
    const [loading, setLoading] = useState(false);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("gb_token", data.access_token);
        localStorage.setItem("gb_user", JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    }, []);

    const loginWithSSO = useCallback(async (ssoToken) => {
        const { data } = await api.post("/auth/sso", { token: ssoToken });
        localStorage.setItem("gb_token", data.access_token);
        localStorage.setItem("gb_user", JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("gb_token");
        localStorage.removeItem("gb_user");
        setUser(null);
    }, []);

    const refresh = useCallback(async () => {
        try {
            setLoading(true);
            const { data } = await api.get("/auth/me");
            localStorage.setItem("gb_user", JSON.stringify(data));
            setUser(data);
        } catch {
            // invalid token - logout silently
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (localStorage.getItem("gb_token") && !user) {
            refresh();
        }
    }, [refresh, user]);

    return (
        <AuthContext.Provider value={{ user, login, loginWithSSO, logout, refresh, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}

export function getToken() {
    return localStorage.getItem("gb_token");
}
